import { useCallback, useContext } from 'react';
import { useDispatch } from 'react-redux';
import core, { API } from '@gin-betting/core';

import ui from 'modules/ui';
import {
    ACTIVE_COUNTRY_KEY_DIVIDER,
    ALL,
    OverlayType,
} from '../../../../constants';
import { MobileFiltersCtx } from '../../MobileFiltersCtx';
import { useCountryInfo } from '../hooks';

interface Input {
    countryCode: string;
    tournaments: API.CategorizerItem[];
}

interface Output {
    handleClickBack: VoidFn;
    handleClickAll: VoidFn;
    totalCount: number;
}

const {
    utils: { setSearchString, getAppliedFilters },
} = core;

const {
    actions: { setActiveMobileCountryKey },
} = ui;

const useActiveRegionItem = ({ countryCode, tournaments }: Input): Output => {
    const dispatch = useDispatch();
    const { setOverlay } = useContext(MobileFiltersCtx);

    const { tournamentIds, totalCount } = useCountryInfo({ tournaments });

    const handleClickBack = useCallback(() => {
        dispatch(setActiveMobileCountryKey(''));

        const currentFilters = getAppliedFilters();

        setSearchString({
            ...currentFilters,
            tournamentIds: undefined,
        });
    }, [dispatch]);

    const handleClickAll = useCallback(() => {
        const currentFilters = getAppliedFilters();
        setSearchString({
            ...currentFilters,
            tournamentIds,
        });

        dispatch(
            setActiveMobileCountryKey(
                `${countryCode}${ACTIVE_COUNTRY_KEY_DIVIDER}${ALL}`
            )
        );
        setOverlay(OverlayType.NONE);
    }, [dispatch, countryCode, setOverlay, tournamentIds]);

    return {
        totalCount,
        handleClickBack,
        handleClickAll,
    };
};

export default useActiveRegionItem;
